import { useMutation } from "@tanstack/react-query";

import { menuQuery, pageQuery, shopQuery } from "../graphql/others-gql";
import { useCacheFirstRequest } from "../graphql/queryClient";
import { locale } from "../locales";
import type { IMenuQuery, IPageQuery, IShopQuery } from "../types/api/shop";
import { ToastType } from "../types/enum";
import { IQueryProps } from "../types/queries";

export default function useStoreInfoQuery({ lang, openToast }: IQueryProps) {
  const request = useCacheFirstRequest();

  const menuMutation = useMutation({
    mutationFn: (variables: Record<string, unknown>) => request<IMenuQuery>("menu", menuQuery, variables),
    onError: (error) => {
      openToast({ message: locale(lang).server, type: ToastType.Error });
      throw new Error(error.message);
    },
  });

  const shopMutation = useMutation({
    mutationFn: () => request<IShopQuery>("shop", shopQuery),
    onError: (error) => {
      openToast({ message: locale(lang).server, type: ToastType.Error });
      throw new Error(error.message);
    },
  });

  const pageMutation = useMutation({
    mutationFn: (variables: Record<string, unknown>) => request<IPageQuery>("page", pageQuery, variables),
    onError: (error) => {
      openToast({ message: locale(lang).server, type: ToastType.Error });
      throw new Error(error.message);
    },
  });

  return {
    fetchMenuData: menuMutation.mutateAsync,
    menuData: menuMutation.data,
    menuDataLoading: menuMutation.isPending,
    fetchShopData: shopMutation.mutateAsync,
    shopData: shopMutation.data,
    shopDataLoading: shopMutation.isPending,
    fetchPageData: pageMutation.mutateAsync,
    pageData: pageMutation.data,
    pageDataLoading: pageMutation.isPending,
  };
}
